import React, { useEffect, useState } from "react";
import { Button, Checkbox, Input, Modal, Radio, Table, Tooltip } from "antd";
import { EditOutlined, DeleteFilled } from "@ant-design/icons";
import "../Pages/CSS/Traitement.css";
import ExportPdf from "./ExportPdf";
import moment from "moment";
import { DocumentService } from "../Services/DocumentService";
import { api_URL } from "../Services/Constantes";
import { FileTextOutlined } from "@ant-design/icons"; // Ajoutez cette ligne en haut si ce n'est pas déjà importé

const TableDOc = ({
  dataSource,
  handleDeleteline,
  loading,
  onEdit,
  isPharmacieComponent,

  showAdditionalColumns,
  onSelectionChange,
  onFilteredDataChange,
}) => {
  const [documentCount, setDocumentCount] = useState(0);
  const [displayedData, setDisplayedData] = useState(dataSource);

  const [totals, setTotals] = useState({
    totalFraisReels: 0,
    totalQPIPM: 0,
    totalQPPart: 0,
  });

  const documentService = new DocumentService();

  useEffect(() => {
    // Réinitialise les données affichées (filtres colonnes) chaque fois que la source change
    setDisplayedData(dataSource);
  }, [dataSource]);

  useEffect(() => {
    // Calculer le nombre total de documents selon le typedoc en tenant compte des filtres de colonnes actifs
    const count = displayedData.filter((doc) => doc.typedoc).length;
    setDocumentCount(count);

    if (showAdditionalColumns) {
      // Calcul des totaux sur les données filtrées
      const totalFraisReels = displayedData.reduce((sum, doc) => sum + (doc.montdoc || 0), 0);
      const totalQPIPM = displayedData.reduce((sum, doc) => sum + (doc.qpmut || 0), 0);
      const totalQPPart = displayedData.reduce((sum, doc) => sum + (doc.ticket || 0), 0);

      setTotals({
        totalFraisReels,
        totalQPIPM,
        totalQPPart,
      });
    }

    if (onFilteredDataChange) {
      onFilteredDataChange(displayedData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayedData, showAdditionalColumns]);

  const handleTableChange = (pagination, filters, sorter, extra) => {
    setDisplayedData(extra.currentDataSource);
  };


  const [pageSize, setPageSize] = useState(10);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const allRowKeys = displayedData.map((record) => record.numdoc);

  useEffect(() => {
    // Écarte les clés qui ne correspondent plus aux données affichées (ex: filtre colonne, suppression, rafraîchissement)
    setSelectedRowKeys((prevKeys) => prevKeys.filter((key) => allRowKeys.includes(key)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayedData]);

  useEffect(() => {
    if (onSelectionChange) {
      const selectedRows = dataSource.filter((record) => selectedRowKeys.includes(record.numdoc));
      onSelectionChange(selectedRowKeys, selectedRows);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRowKeys]);

  const handleSelectAllChange = (e) => {
    setSelectedRowKeys(e.target.checked ? allRowKeys : []);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys) => setSelectedRowKeys(keys),
    columnTitle: (
      <Checkbox
        checked={allRowKeys.length > 0 && selectedRowKeys.length === allRowKeys.length}
        indeterminate={selectedRowKeys.length > 0 && selectedRowKeys.length < allRowKeys.length}
        onChange={handleSelectAllChange}
      />
    ),
  };
  //separateur milieu
  const formatNumberWithSeparator = (number) => {
    return number.toLocaleString(); // Utilisez cette fonction pour formater les nombres
  };
  const commonColumns = [
    {
      title: "Numero",
      dataIndex: "numdoc",
      key: "numdoc",
      align: "center",
      fixed: "left",
      render: (text) => <strong>{text}</strong>,
      sorter: (a, b) => {
        const valueA = a.numdoc || "";
        const valueB = b.numdoc || "";
        return valueA.localeCompare(valueB);
      },
      filters: [
        ...new Set(
          dataSource.map((item) => item?.numdoc).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        ),
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.numdoc === value,
    },
    {
      title: "Date",
      dataIndex: "datedoc",
      key: "datedoc",
      align: "center",
      render: (text) => moment(text).format("DD/MM/YYYY"),
      sorter: (a, b) => {
        const valueA = new Date(a.datedoc).getTime();
        const valueB = new Date(b.datedoc).getTime();
        return valueA - valueB;
      },
    },
    {
      title: "Mat. Part.",
      dataIndex: "matripart",
      key: "matripart",
      align: "center",
      sorter: (a, b) => {
        const valueA = a.matripart || "";
        const valueB = b.matripart || "";
        return valueA.localeCompare(valueB);
      },
      filters: [
        ...new Set(
          dataSource.map((item) => item?.matripart).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        ),
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.matripart === value,
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingLeft: "5px", paddingRight: "5px",
          }}
        > Participant</div>
      ),
      // title: "Participant",
      dataIndex: "participant",
      key: "participant",
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap", paddingLeft: "5px", paddingRight: "5px", }}>
          {(text)}
        </div>
      ),
      sorter: (a, b) => {
        const valueA = a.participant || "";
        const valueB = b.participant || "";
        return valueA.localeCompare(valueB);
      },
      filters: [
        ...new Set(
          dataSource.map((item) => item?.participant).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        ),
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.participant === value,
    },
    {
      title: "Type bénéf.",
      dataIndex: "typebenef",
      key: "typebenef",
      align: "center",
      sorter: (a, b) => {
        const valueA = a.typebenef || "";
        const valueB = b.typebenef || "";
        return valueA.localeCompare(valueB);
      },
      filters: [
        ...new Set(
          dataSource.map((item) => item?.typebenef).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        ),
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.typebenef === value,
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingLeft: "5px", paddingRight: "5px",
          }}
        > Bénéficiaire</div>
      ),
      //   title: "Bénéficiaire",
      dataIndex: "beneficiaire",
      key: "beneficiaire",
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap", paddingLeft: "5px", paddingRight: "5px", }}>
          {(text)}
        </div>
      ),
      sorter: (a, b) => {
        const valueA = a.beneficiaire || "";
        const valueB = b.beneficiaire || "";
        return valueA.localeCompare(valueB);
      },
      filters: [
        ...new Set(
          dataSource.map((item) => item?.beneficiaire).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        ),
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.beneficiaire === value,
    },
    {
      title: "Code F.",
      dataIndex: "codefourn",
      key: "codefourn",
      align: "center",
      sorter: (a, b) => {
        const valueA = a.codefourn || "";
        const valueB = b.codefourn || "";
        return valueA.localeCompare(valueB);
      },
      filters: [
        ...new Set(
          dataSource.map((item) => item?.codefourn).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        ),
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.codefourn === value,
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingLeft: "5px", paddingRight: "5px",
          }}
        > {isPharmacieComponent ? "Pharmacie" : "Fournisseur"}</div>
      ),
      // title: isPharmacieComponent ? "Pharmacie" : "Fournisseur",
      dataIndex: "fournisseur",
      key: "fournisseur",
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap", paddingLeft: "5px", paddingRight: "5px", }}>
          {(text)}
        </div>
      ),
      sorter: (a, b) => {
        const valueA = a.fournisseur || "";
        const valueB = b.fournisseur || "";
        return valueA.localeCompare(valueB);
      },
      filters: [
        ...new Set(
          dataSource.map((item) => item?.fournisseur).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
        ),
      ].map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record.fournisseur === value,
    },
  ];
  const additionalColumns = [
    {
      title: "N° Facture",
      dataIndex: "numfact",
      key: "numfact",
      align: "center",
      render: (text) => <strong>{text}</strong>,
      sorter: (a, b) => {
        const valueA = a.numfact || "";
        const valueB = b.numfact || "";
        return valueA.localeCompare(valueB);
      },
    },

    {
      title: "Frais réels",
      dataIndex: "montdoc",
      key: "montdoc",
      align: "right",
      render: (text) => <strong>{formatNumberWithSeparator(text)}</strong>,
      sorter: (a, b) => {
        const valueA = a.montdoc || "";
        const valueB = b.montdoc || "";
        return valueA.localeCompare(valueB);
      },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8, width: 200 }}>
          {/* Recherche personnalisée */}
          <Input
            placeholder="Rechercher montant"
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys([e.target.value])}
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8 }}
          />
          {/* Plages de filtres prédéfinies */}
          <div style={{ marginBottom: 8 }}>
            <Radio.Group
              onChange={(e) => {
                setSelectedKeys([e.target.value]);
                confirm();
              }}
              value={selectedKeys[0]}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Radio value="100-100000">100 - 100,000</Radio>
              <Radio value="100000-1000000">100,000 - 1,000,000</Radio>
              <Radio value="1000000-">Plus de 1,000,000</Radio>
            </Radio.Group>
          </div>

          {/* Boutons */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: "48%" }}
            >
              Reset
            </Button>
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              style={{ width: "48%" }}
            >
              Ok
            </Button>
          </div>
        </div>
      ),
      onFilter: (value, record) => {
        if (value.includes("-")) {
          const [min, max] = value.split("-").map(Number);
          if (!max) return record.montdoc >= min; // Plus de 1,000,000
          return record.montdoc >= min && record.montdoc <= max; // Plage spécifique
        }
        const parsedValue = parseFloat(value);
        return record.montdoc === parsedValue; // Recherche directe
      },
    },
    {
      title: "QP IPM",
      dataIndex: "qpmut",
      key: "qpmut",
      align: "right",
      render: (text) => <strong>{formatNumberWithSeparator(text)}</strong>,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8, width: 200 }}>
          {/* Recherche personnalisée */}
          <Input
            placeholder="Rechercher montant"
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys([e.target.value])}
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8 }}
          />
          {/* Plages de filtres prédéfinies */}
          <div style={{ marginBottom: 8 }}>
            <Radio.Group
              onChange={(e) => {
                setSelectedKeys([e.target.value]);
                confirm();
              }}
              value={selectedKeys[0]}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Radio value="100-100000">100 - 100,000</Radio>
              <Radio value="100000-1000000">100,000 - 1,000,000</Radio>
              <Radio value="1000000-">Plus de 1,000,000</Radio>
            </Radio.Group>
          </div>

          {/* Boutons */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: "48%" }}
            >
              Reset
            </Button>
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              style={{ width: "48%" }}
            >
              Ok
            </Button>
          </div>
        </div>
      ),
      onFilter: (value, record) => {
        if (value.includes("-")) {
          const [min, max] = value.split("-").map(Number);
          if (!max) return record.qpmut >= min; // Plus de 1,000,000
          return record.qpmut >= min && record.qpmut <= max; // Plage spécifique
        }
        const parsedValue = parseFloat(value);
        return record.qpmut === parsedValue; // Recherche directe
      },
      sorter: (a, b) => {
        const valueA = a.qpmut || "";
        const valueB = b.qpmut || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "QP Part",
      dataIndex: "ticket",
      key: "ticket",
      align: "right",
      render: (text) => <strong>{formatNumberWithSeparator(text)}</strong>,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8, width: 200 }}>
          {/* Recherche personnalisée */}
          <Input
            placeholder="Rechercher montant"
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys([e.target.value])}
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8 }}
          />
          {/* Plages de filtres prédéfinies */}
          <div style={{ marginBottom: 8 }}>
            <Radio.Group
              onChange={(e) => {
                setSelectedKeys([e.target.value]);
                confirm();
              }}
              value={selectedKeys[0]}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Radio value="100-100000">100 - 100,000</Radio>
              <Radio value="100000-1000000">100,000 - 1,000,000</Radio>
              <Radio value="1000000-">Plus de 1,000,000</Radio>
            </Radio.Group>
          </div>

          {/* Boutons */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: "48%" }}
            >
              Reset
            </Button>
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              style={{ width: "48%" }}
            >
              Ok
            </Button>
          </div>
        </div>
      ),
      onFilter: (value, record) => {
        if (value.includes("-")) {
          const [min, max] = value.split("-").map(Number);
          if (!max) return record.ticket >= min; // Plus de 1,000,000
          return record.ticket >= min && record.ticket <= max; // Plage spécifique
        }
        const parsedValue = parseFloat(value);
        return record.ticket === parsedValue; // Recherche directe
      },
      sorter: (a, b) => {
        const valueA = a.ticket || "";
        const valueB = b.ticket || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "QP Mut.",
      dataIndex: "qpassur",
      key: "qpassur",
      align: "right",
      render: (text) => <strong>{formatNumberWithSeparator(text)}</strong>,
      sorter: (a, b) => {
        const valueA = a.qpassur || "";
        const valueB = b.qpassur || "";
        return valueA.localeCompare(valueB);
      },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8, width: 200 }}>
          {/* Recherche personnalisée */}
          <Input
            placeholder="Rechercher montant"
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys([e.target.value])}
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8 }}
          />
          {/* Plages de filtres prédéfinies */}
          <div style={{ marginBottom: 8 }}>
            <Radio.Group
              onChange={(e) => {
                setSelectedKeys([e.target.value]);
                confirm();
              }}
              value={selectedKeys[0]}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Radio value="100-100000">100 - 100,000</Radio>
              <Radio value="100000-1000000">100,000 - 1,000,000</Radio>
              <Radio value="1000000-">Plus de 1,000,000</Radio>
            </Radio.Group>
          </div>

          {/* Boutons */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: "48%" }}
            >
              Reset
            </Button>
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              style={{ width: "48%" }}
            >
              Ok
            </Button>
          </div>
        </div>
      ),
      onFilter: (value, record) => {
        if (value.includes("-")) {
          const [min, max] = value.split("-").map(Number);
          if (!max) return record.qpassur >= min; // Plus de 1,000,000
          return record.qpassur >= min && record.qpassur <= max; // Plage spécifique
        }
        const parsedValue = parseFloat(value);
        return record.qpassur === parsedValue; // Recherche directe
      },
    },
    {
      title: "F.Exclus.",
      dataIndex: "fexclus",
      key: "fexclus",
      align: "right",
      render: (text) => <strong>{formatNumberWithSeparator(text)}</strong>,
      sorter: (a, b) => {
        const valueA = a.fexclus || "";
        const valueB = b.fexclus || "";
        return valueA.localeCompare(valueB);
      },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8, width: 200 }}>
          {/* Recherche personnalisée */}
          <Input
            placeholder="Rechercher montant"
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys([e.target.value])}
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8 }}
          />
          {/* Plages de filtres prédéfinies */}
          <div style={{ marginBottom: 8 }}>
            <Radio.Group
              onChange={(e) => {
                setSelectedKeys([e.target.value]);
                confirm();
              }}
              value={selectedKeys[0]}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Radio value="100-100000">100 - 100,000</Radio>
              <Radio value="100000-1000000">100,000 - 1,000,000</Radio>
              <Radio value="1000000-">Plus de 1,000,000</Radio>
            </Radio.Group>
          </div>

          {/* Boutons */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: "48%" }}
            >
              Reset
            </Button>
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              style={{ width: "48%" }}
            >
              Ok
            </Button>
          </div>
        </div>
      ),
      onFilter: (value, record) => {
        if (value.includes("-")) {
          const [min, max] = value.split("-").map(Number);
          if (!max) return record.fexclus >= min; // Plus de 1,000,000
          return record.fexclus >= min && record.fexclus <= max; // Plage spécifique
        }
        const parsedValue = parseFloat(value);
        return record.fexclus === parsedValue; // Recherche directe
      },
    },

  ];
  const actionsColumn = {
    title: (
      <div
        style={{
          backgroundColor: "#010f1c",
          color: "white",
          padding: "1px",
        }}
      ></div>
    ),
    dataIndex: "actions",
    key: "actions",
    align: "center",
    fixed: "right", // Fixe la colonne à droite
    render: (text, record) => (
      <span>
        <Tooltip title="Imprimer">
          <ExportPdf numdoc={record.numdoc} typeImpression={record.type_impression} />
        </Tooltip>
        <Tooltip title="Modifier">
          <EditOutlined
            style={{ cursor: "pointer", color: "orange", marginRight: 8 }}
            onClick={() => onEdit(record)}
          />
        </Tooltip>
        {record.ordonnance === "Oui" && (
          <Tooltip title="Voir Ordonnance">
            <FileTextOutlined
              style={{ cursor: "pointer", color: "red", marginRight: 8 }}
              onClick={() => handlePreviewOrdonance(record.numdoc)}
            />
          </Tooltip>
        )}
        <Tooltip title="Supprimer">
          <DeleteFilled style={{ cursor: "pointer", color: "red" }} onClick={() => handleDeleteline(record.numdoc)} />
        </Tooltip>
      </span>
    ),
  };
  const actionsColumn1 = {
    title: (
      <div
        style={{
          backgroundColor: "#010f1c",
          color: "white",
          padding: "1px",
        }}
      ></div>
    ),
    dataIndex: "actions",
    key: "actions",
    align: "center",
    fixed: "right", // Fixe la colonne à droite
    render: (text, record) => (
      <span>
        {/*   <Tooltip title="Imprimer">
          <ExportPdf numdoc={record.numdoc} />
        </Tooltip> */}
        {/* <Tooltip title="Modifier">
          <EditOutlined
            style={{ cursor: "pointer", color: "orange", marginRight: 8 }}
            onClick={() => onEdit(record)}
          />
        </Tooltip> */}

        {/*   <Tooltip title="Supprimer">
            <DeleteFilled style={{ cursor: "pointer", color: "red" }}  onClick={() => handleDeleteline(record.numdoc)} />
          </Tooltip> */}

      </span>
    ),
  };

  const etabliParColumn = {
    title: "Etabli Par",
    dataIndex: "user_id",
    key: "user_id",
    align: "center",
    sorter: (a, b) => {
      const valueA = a.user_id || "";
      const valueB = b.user_id || "";
      return valueA.localeCompare(valueB);
    },
    filters: [
      ...new Set(
        dataSource.map((item) => item?.user_id).filter((value) => value)
      ),
    ].map((value) => ({
      text: value,
      value: value,
    })),
    onFilter: (value, record) => record.user_id === value,
  };

  const handlePreviewOrdonance = async (numdoc) => {
    try {
      const response_url = `${api_URL}/Document/getOrdonnance/${numdoc}`;

      if (response_url) {
        window.open(response_url, "_blank");
      } else {
        console.error("URL d'ordonnance non trouvée");
        Modal.info({
          title: "Information",
          content: "Aucune ordonnance disponible pour ce document.",
        });
      }
    } catch (error) {
      console.error("Erreur lors de la récupération de l'ordonnance :", error);
    }
  };

  const columns = showAdditionalColumns
    ? [...commonColumns, ...additionalColumns, etabliParColumn, actionsColumn1]
    : [...commonColumns, etabliParColumn, actionsColumn];


  return (
    <Table
      title={() => (
        <div style={{ fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span>
            Nombre total de documents : <strong>{documentCount}</strong>
          </span>
          {showAdditionalColumns && (
            <span style={{ marginLeft: "auto", fontWeight: "normal" }}>
              Total Frais réels : <strong>{formatNumberWithSeparator(totals.totalFraisReels)}</strong> | Total QP IPM :{" "}
              <strong>{formatNumberWithSeparator(totals.totalQPIPM)}</strong> | Total QP Part. :{" "}
              <strong>{formatNumberWithSeparator(totals.totalQPPart)}</strong>
            </span>
          )}
        </div>
      )}
      scroll={{
        x: true,
      }}
      showSorterTooltip={false}
      // style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
      pagination={{
        pageSizeOptions: ["5", "10", "20", "50", "100"],
        showSizeChanger: true,
        pageSize: pageSize,
        onShowSizeChange: (current, size) => setPageSize(size),
      }}
      className="custom-header2-table my-custom-table"
      style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
      bordered
      loading={loading}
      dataSource={dataSource}
      columns={columns}
      rowKey="numdoc"
      rowSelection={rowSelection}
      onChange={handleTableChange}

    />
  );
};

export default TableDOc;
